function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable */
import React from 'react';
import { FiltersDropButton } from '../components';
import { Box } from 'grommet';
// import dragLogo from 'granite-admin/core/components/Table/drag.png';
import { Drag } from 'grommet-icons';
export function useUtilsColumns(hooks, ...rest) {
  hooks.allColumns.push((columns, {
    instance
  }) => {
    const {
      utilsColumnPosition = 0,
      visibilityColumnPosition,
      columnsHideable,
      expandable: defaultExpandable,
      draggable: defaultDraggable,
      UtilsHeader,
      RowExpandCell,
      hideDefaultDraggable,
      hideDefaultExpandable,
      state: {
        hiddenColumns
      }
    } = instance;
    let newColumns = [...columns];
    let draggable = defaultDraggable && !hideDefaultDraggable;
    let expandable = defaultExpandable && !hideDefaultExpandable;
    if (!columnsHideable && !draggable && !expandable) return newColumns;
    if (!visibilityColumnPosition) {
      newColumns.splice(utilsColumnPosition, 0, {
        id: 'utils',
        Header: props => /*#__PURE__*/React.createElement("div", {
          className: "utils-header"
        }, columnsHideable ? /*#__PURE__*/React.createElement(FiltersDropButton, _extends({}, props, {
          hiddenColumnsArray: hiddenColumns,
          tableCols: instance.columns,
          showHideColsHandler: instance.setHiddenColumns
          // disableHideCells={disableHideCells}
        })) : /*#__PURE__*/React.createElement(UtilsHeader, null)),
        Cell: props => /*#__PURE__*/React.createElement(Box, {
          align: "center",
          direction: "row",
          className: "utils-cell",
          onClick: e => e.stopPropagation(),
          focusIndicator: false
        }, draggable ? /*#__PURE__*/React.createElement(Drag, {
          size: "small",
          className: "rt-hover-visible",
          color: "#c6c6c6"
        }) : null, expandable ? /*#__PURE__*/React.createElement(RowExpandCell, props) : null),
        disableResizing: true,
        disableSortBy: true,
        disableOrdering: true,
        ...(!(expandable && draggable) || !expandable && !draggable ? {
          minWidth: 32,
          width: 32,
          maxWidth: 32
        } : {
          minWidth: 50,
          width: 50,
          maxWidth: 50
        })
      });
    } else {
      if (columnsHideable) newColumns.splice(visibilityColumnPosition, 0, {
        id: 'column-visibility',
        Header: props => /*#__PURE__*/React.createElement("div", {
          className: "column-visibility-header"
        }, /*#__PURE__*/React.createElement(FiltersDropButton, _extends({}, props, {
          hiddenColumnsArray: hiddenColumns,
          tableCols: instance.columns,
          showHideColsHandler: instance.setHiddenColumns
          // disableHideCells={disableHideCells}
        }))),

        disableResizing: true,
        disableSortBy: true,
        disableOrdering: true,
        minWidth: 32,
        width: 32,
        maxWidth: 32
      });
      if (draggable || expandable) newColumns.splice(utilsColumnPosition, 0, {
        id: 'utils',
        Header: () => /*#__PURE__*/React.createElement("div", {
          className: "utils-header"
        }, /*#__PURE__*/React.createElement(UtilsHeader, null)),
        Cell: ({
          row
        }) => /*#__PURE__*/React.createElement(Box, {
          align: "center",
          direction: "row",
          className: "utils-cell",
          onClick: e => e.stopPropagation(),
          focusIndicator: false
        }, draggable ? /*#__PURE__*/React.createElement(Drag, {
          size: "small",
          className: "rt-hover-visible",
          color: "#c6c6c6"
        }) : null, expandable ? /*#__PURE__*/React.createElement(RowExpandCell, props) : null),
        disableResizing: true,
        disableSortBy: true,
        collapsed: true,
        disableOrdering: true,
        ...(!(expandable && draggable) || !expandable && !draggable ? {
          minWidth: 32,
          width: 32,
          maxWidth: 32
        } : {
          minWidth: 50,
          width: 50,
          maxWidth: 50
        })
      });
    }
    return [...newColumns];
  });
}
useUtilsColumns.pluginName = 'useUtilsColumns';